import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import PaymentsAPI from 'api/PaymentsAPI';

const StyledTableCell = styled(TableCell)(() => ({
  border: 0,
  [`&.${tableCellClasses.head}`]: {
    color: '#BDBEC1',
    backgroundColor:'#2E3036',
    fontSize: 12,
    fontFamily: 'Inter',
    fontWeight: 500
  },
  [`&.${tableCellClasses.body}`]: {
    color: '#EFF1F6',
    fontSize: 14,
    fontFamily: 'Inter',
    fontWeight: 400
  },
}));

const BlankTableCell = styled(TableCell)(() => ({
  color: '#BDBEC1',
  border: 0,
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    backgroundColor:'#2E3036',
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  backgroundColor: '#202227',
  borderBottom: '1px solid #2E3036',
}));

interface ITableProps {
  stripeCus: any;
  handleTabChange?: any;
}


const MeterTable: React.FC<ITableProps> = (props: ITableProps) => {
  const { stripeCus, handleTabChange } = props;

  const [ planInfo, setPlanInfo ] = useState<any>({
    isLoading: true,
    data: []
  });

  const convertAmount = (amount: any) => {
    const total = amount / 100;
    return total.toFixed(2);
  };

  const convertTimestamp = (time: any) => {
    let date: any = new Date(time * 1000);
    date = `${date.getMonth() + 1 }/${ date.getDate() }/${ date.getFullYear()}`;
    return date;
  };

  const getMeterTotal = async(sub: string, cus: string) => {
    const res = await PaymentsAPI.upcomingInvoice({
      cus_id: cus,
      sub_id: sub
    });
    return res?.result?.lines?.data[0];
  };

  const getPlanInfo = () => {
    let plansArr: any[] = [ {
      name: 'People / Companies',
      active: false,
    },
    {
      name: 'Products',
      active: false,
    },
    {
      name: 'Automation',
      active: false,
    }, ];
    if (stripeCus.subscriptions.data.length > 0) {
      stripeCus.subscriptions.data.map(async(sub: any) => {
        if (sub.metadata.moduleName === 'Full Access' && sub.plan.active) {
          plansArr = [ 'Full Access', convertTimestamp(sub.current_period_end), sub.plan.amount ];
        } else if (sub.metadata.moduleName === 'Public API Entity API Subscription' || sub.metadata.moduleName === 'Public API Commodity API Subscription' || sub.metadata.moduleName === 'Automations') {
          let calls = 0;
          let amount = 0;
          await getMeterTotal(sub.id, stripeCus.id).then((obj: any) => {
            if (obj) {
              calls = obj.quantity;
              amount = obj.amount;
            }
          });
          const obj = {
            name: sub.metadata.moduleName,
            type: sub.plan.usage_type,
            active: sub.plan.active,
            nextPayment: convertTimestamp(sub.current_period_end),
            calls: calls,
            amount: sub.plan.usage_type === 'licensed' ? sub.plan.amount : amount,
          };
          if (sub.metadata.moduleName === 'Public API Entity API Subscription') {
            plansArr[0] = obj;
          } else if (sub.metadata.moduleName === 'Public API Commodity API Subscription') {
            plansArr[1] = obj;
          } else {
            plansArr[2] = obj;
          }
        }
        setPlanInfo({ isLoading: false, data: plansArr });
      });
    } else {
      setPlanInfo({ isLoading: false, data: [] });
    }
  };

  useEffect(() => {
    getPlanInfo();
  }, [ stripeCus ]);

  return (
    <TableContainer component={Paper} className='api-table-paper'>
      <div className='overage-fees-table-header'>
        <div className='overage-fees-table-header-content'>
          <div className='overage-fees-table-header-text-group'>
            <div className='overage-fees-table-header-text-frame'>
              <div className='overage-fees-table-header-title'>
                External API Meters
              </div>
              <div
                className='overage-fees-table-toggle'
                onClick={() => {
                  handleTabChange('Plans');
                }}
              >
                <div className='overage-fees-table-toggle-text'>
                  Manage Plans
                </div>
                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                  <path d='M5.83334 14.1663L14.1667 5.83301M14.1667 5.83301H5.83334M14.1667 5.83301V14.1663' stroke='#CECFD2' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Table sx={{ minWidth: 650 }} aria-label='simple table'>
        <TableHead className='api-table-head'>
          <TableRow>
            <StyledTableCell>API Endpoint</StyledTableCell>
            <StyledTableCell>Next Payment</StyledTableCell>
            <StyledTableCell>Monthly Calls</StyledTableCell>
            <StyledTableCell>Monthly Amount</StyledTableCell>
          </TableRow>
        </TableHead>
        {!planInfo.isLoading && planInfo.data.length === 0 && (
          <TableBody>

            <StyledTableRow
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <StyledTableCell component='th' scope='row'>
        People / Companies
              </StyledTableCell>
              <StyledTableCell component='th' scope='row'>
        -
              </StyledTableCell>
              <StyledTableCell component='th' scope='row'>
              -
              </StyledTableCell>
              <StyledTableCell component='th' scope='row'>
                <Link
                  to={{
                    pathname: '/profile',
                    state: {
                      linkTab: 'Plans'
                    }
                  }}
                  style={{ color: '#4895EF',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: '600',
                    lineHeight: '20px'
                  }}
                >
                    + Add to Plan
                </Link>
              </StyledTableCell>
            </StyledTableRow>
            <StyledTableRow
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <StyledTableCell component='th' scope='row'>
        Products
              </StyledTableCell>
              <StyledTableCell component='th' scope='row'>
        -
              </StyledTableCell>
              <StyledTableCell component='th' scope='row'>
              -
              </StyledTableCell>
              <StyledTableCell component='th' scope='row'>
                <Link
                  to={{
                    pathname: '/profile',
                    state: {
                      linkTab: 'Plans'
                    }
                  }}
                  style={{ color: '#4895EF',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: '600',
                    lineHeight: '20px'
                  }}
                >
                    + Add to Plan
                </Link>
              </StyledTableCell>
            </StyledTableRow>
            <StyledTableRow
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <StyledTableCell component='th' scope='row'>
       Automation
              </StyledTableCell>
              <StyledTableCell component='th' scope='row'>
        -
              </StyledTableCell>
              <StyledTableCell component='th' scope='row'>
              -
              </StyledTableCell>
              <StyledTableCell component='th' scope='row'>
                <Link
                  to={{
                    pathname: '/profile',
                    state: {
                      linkTab: 'Plans'
                    }
                  }}
                  style={{ color: '#4895EF',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: '600',
                    lineHeight: '20px'
                  }}
                >
                    + Add to Plan
                </Link>
              </StyledTableCell>
            </StyledTableRow>
          </TableBody>
        )}
        {planInfo.isLoading ? (
          <div className='spinner-spacer-top'>
            <div className='loader'>Loading...</div>
          </div>
        ) : planInfo.data[0] === 'Full Access' ? (
          <TableBody>

            <StyledTableRow
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <StyledTableCell component='th' scope='row'>
                    People / Companies
              </StyledTableCell>
              <StyledTableCell component='th' scope='row'>
                    -
              </StyledTableCell>
              <StyledTableCell component='th' scope='row'>
                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='10' viewBox='0 0 20 10' fill='none'>
                  <path d='M15.4481 0.383179C13.9656 0.383179 12.6038 1.5063 11.4713 2.53068C10.8519 3.09005 10.3594 3.6038 10.0013 3.99568C9.645 3.6038 9.15438 3.09005 8.53312 2.53068C7.4 1.5063 6.04 0.383179 4.55687 0.383179C2.04375 0.383179 0 2.46318 0 5.00005C0 7.53693 2.04375 9.61693 4.55687 9.61693C6.04 9.61693 7.40125 8.4938 8.53312 7.46943C9.15312 6.91005 9.64375 6.3963 10.0013 6.00443C10.3581 6.3963 10.8506 6.91005 11.4713 7.46943C12.6044 8.4938 13.9656 9.61693 15.4481 9.61693C17.9606 9.61693 20 7.53693 20 5.00005C20 2.46318 17.9613 0.383179 15.4481 0.383179ZM7.63812 6.48193C6.585 7.43255 5.22312 8.28255 4.55687 8.28255C2.77437 8.28255 1.33312 6.8263 1.33312 5.00005C1.33312 3.1738 2.77562 1.71755 4.55687 1.71755C5.22187 1.71755 6.585 2.56693 7.63812 3.51818C8.45562 4.25693 8.81938 4.70443 9.07625 5.00005C8.81875 5.29568 8.455 5.74318 7.63812 6.48193ZM15.4481 8.28255C14.7831 8.28255 13.4194 7.43318 12.3662 6.48193C11.5506 5.74443 11.1856 5.29568 10.9288 5.00005C11.1856 4.70443 11.5506 4.25568 12.3662 3.51818C13.4194 2.56755 14.7819 1.71755 15.4481 1.71755C17.2306 1.71755 18.6663 3.1738 18.6663 5.00005C18.6663 6.8263 17.23 8.28255 15.4481 8.28255Z' fill='#EFF1F6'/>
                </svg>
              </StyledTableCell>
              <BlankTableCell component='th' scope='row'>
              </BlankTableCell>
            </StyledTableRow>
            <StyledTableRow
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <StyledTableCell component='th' scope='row'>
                    Products
              </StyledTableCell>
              <StyledTableCell component='th' scope='row'>
                    -
              </StyledTableCell>
              <StyledTableCell component='th' scope='row'>
                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='10' viewBox='0 0 20 10' fill='none'>
                  <path d='M15.4481 0.383179C13.9656 0.383179 12.6038 1.5063 11.4713 2.53068C10.8519 3.09005 10.3594 3.6038 10.0013 3.99568C9.645 3.6038 9.15438 3.09005 8.53312 2.53068C7.4 1.5063 6.04 0.383179 4.55687 0.383179C2.04375 0.383179 0 2.46318 0 5.00005C0 7.53693 2.04375 9.61693 4.55687 9.61693C6.04 9.61693 7.40125 8.4938 8.53312 7.46943C9.15312 6.91005 9.64375 6.3963 10.0013 6.00443C10.3581 6.3963 10.8506 6.91005 11.4713 7.46943C12.6044 8.4938 13.9656 9.61693 15.4481 9.61693C17.9606 9.61693 20 7.53693 20 5.00005C20 2.46318 17.9613 0.383179 15.4481 0.383179ZM7.63812 6.48193C6.585 7.43255 5.22312 8.28255 4.55687 8.28255C2.77437 8.28255 1.33312 6.8263 1.33312 5.00005C1.33312 3.1738 2.77562 1.71755 4.55687 1.71755C5.22187 1.71755 6.585 2.56693 7.63812 3.51818C8.45562 4.25693 8.81938 4.70443 9.07625 5.00005C8.81875 5.29568 8.455 5.74318 7.63812 6.48193ZM15.4481 8.28255C14.7831 8.28255 13.4194 7.43318 12.3662 6.48193C11.5506 5.74443 11.1856 5.29568 10.9288 5.00005C11.1856 4.70443 11.5506 4.25568 12.3662 3.51818C13.4194 2.56755 14.7819 1.71755 15.4481 1.71755C17.2306 1.71755 18.6663 3.1738 18.6663 5.00005C18.6663 6.8263 17.23 8.28255 15.4481 8.28255Z' fill='#EFF1F6'/>
                </svg>
              </StyledTableCell>
              <BlankTableCell component='th' scope='row'>
              </BlankTableCell>
            </StyledTableRow>
            <StyledTableRow
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <StyledTableCell component='th' scope='row'>
                   Automation
              </StyledTableCell>
              <StyledTableCell component='th' scope='row'>
                    -
              </StyledTableCell>
              <StyledTableCell component='th' scope='row'>
                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='10' viewBox='0 0 20 10' fill='none'>
                  <path d='M15.4481 0.383179C13.9656 0.383179 12.6038 1.5063 11.4713 2.53068C10.8519 3.09005 10.3594 3.6038 10.0013 3.99568C9.645 3.6038 9.15438 3.09005 8.53312 2.53068C7.4 1.5063 6.04 0.383179 4.55687 0.383179C2.04375 0.383179 0 2.46318 0 5.00005C0 7.53693 2.04375 9.61693 4.55687 9.61693C6.04 9.61693 7.40125 8.4938 8.53312 7.46943C9.15312 6.91005 9.64375 6.3963 10.0013 6.00443C10.3581 6.3963 10.8506 6.91005 11.4713 7.46943C12.6044 8.4938 13.9656 9.61693 15.4481 9.61693C17.9606 9.61693 20 7.53693 20 5.00005C20 2.46318 17.9613 0.383179 15.4481 0.383179ZM7.63812 6.48193C6.585 7.43255 5.22312 8.28255 4.55687 8.28255C2.77437 8.28255 1.33312 6.8263 1.33312 5.00005C1.33312 3.1738 2.77562 1.71755 4.55687 1.71755C5.22187 1.71755 6.585 2.56693 7.63812 3.51818C8.45562 4.25693 8.81938 4.70443 9.07625 5.00005C8.81875 5.29568 8.455 5.74318 7.63812 6.48193ZM15.4481 8.28255C14.7831 8.28255 13.4194 7.43318 12.3662 6.48193C11.5506 5.74443 11.1856 5.29568 10.9288 5.00005C11.1856 4.70443 11.5506 4.25568 12.3662 3.51818C13.4194 2.56755 14.7819 1.71755 15.4481 1.71755C17.2306 1.71755 18.6663 3.1738 18.6663 5.00005C18.6663 6.8263 17.23 8.28255 15.4481 8.28255Z' fill='#EFF1F6'/>
                </svg>
              </StyledTableCell>
              <BlankTableCell component='th' scope='row'>
              </BlankTableCell>
            </StyledTableRow>
            <StyledTableRow
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <StyledTableCell component='th' scope='row'>
                    Full Access
              </StyledTableCell>
              <StyledTableCell component='th' scope='row'>
                {planInfo.data[1]}
              </StyledTableCell>
              <StyledTableCell component='th' scope='row'>
                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='10' viewBox='0 0 20 10' fill='none'>
                  <path d='M15.4481 0.383179C13.9656 0.383179 12.6038 1.5063 11.4713 2.53068C10.8519 3.09005 10.3594 3.6038 10.0013 3.99568C9.645 3.6038 9.15438 3.09005 8.53312 2.53068C7.4 1.5063 6.04 0.383179 4.55687 0.383179C2.04375 0.383179 0 2.46318 0 5.00005C0 7.53693 2.04375 9.61693 4.55687 9.61693C6.04 9.61693 7.40125 8.4938 8.53312 7.46943C9.15312 6.91005 9.64375 6.3963 10.0013 6.00443C10.3581 6.3963 10.8506 6.91005 11.4713 7.46943C12.6044 8.4938 13.9656 9.61693 15.4481 9.61693C17.9606 9.61693 20 7.53693 20 5.00005C20 2.46318 17.9613 0.383179 15.4481 0.383179ZM7.63812 6.48193C6.585 7.43255 5.22312 8.28255 4.55687 8.28255C2.77437 8.28255 1.33312 6.8263 1.33312 5.00005C1.33312 3.1738 2.77562 1.71755 4.55687 1.71755C5.22187 1.71755 6.585 2.56693 7.63812 3.51818C8.45562 4.25693 8.81938 4.70443 9.07625 5.00005C8.81875 5.29568 8.455 5.74318 7.63812 6.48193ZM15.4481 8.28255C14.7831 8.28255 13.4194 7.43318 12.3662 6.48193C11.5506 5.74443 11.1856 5.29568 10.9288 5.00005C11.1856 4.70443 11.5506 4.25568 12.3662 3.51818C13.4194 2.56755 14.7819 1.71755 15.4481 1.71755C17.2306 1.71755 18.6663 3.1738 18.6663 5.00005C18.6663 6.8263 17.23 8.28255 15.4481 8.28255Z' fill='#EFF1F6'/>
                </svg>
              </StyledTableCell>
              <BlankTableCell component='th' scope='row'>
                {`$${convertAmount(planInfo.data[2])}`}
              </BlankTableCell>
            </StyledTableRow>

          </TableBody>
        ) : (
          <TableBody>
            {planInfo.data.map((plan: any, i: number) => (
              <StyledTableRow key={i}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <StyledTableCell component='th' scope='row'>
                  {plan.name}
                </StyledTableCell>
                <StyledTableCell component='th' scope='row'>
                  {!plan.active ? '-' : plan.nextPayment}
                </StyledTableCell>
                <StyledTableCell component='th' scope='row'>
                  {!plan.active ? '-' : plan.type === 'licensed' ? <svg xmlns='http://www.w3.org/2000/svg' width='20' height='10' viewBox='0 0 20 10' fill='none'>
                    <path d='M15.4481 0.383179C13.9656 0.383179 12.6038 1.5063 11.4713 2.53068C10.8519 3.09005 10.3594 3.6038 10.0013 3.99568C9.645 3.6038 9.15438 3.09005 8.53312 2.53068C7.4 1.5063 6.04 0.383179 4.55687 0.383179C2.04375 0.383179 0 2.46318 0 5.00005C0 7.53693 2.04375 9.61693 4.55687 9.61693C6.04 9.61693 7.40125 8.4938 8.53312 7.46943C9.15312 6.91005 9.64375 6.3963 10.0013 6.00443C10.3581 6.3963 10.8506 6.91005 11.4713 7.46943C12.6044 8.4938 13.9656 9.61693 15.4481 9.61693C17.9606 9.61693 20 7.53693 20 5.00005C20 2.46318 17.9613 0.383179 15.4481 0.383179ZM7.63812 6.48193C6.585 7.43255 5.22312 8.28255 4.55687 8.28255C2.77437 8.28255 1.33312 6.8263 1.33312 5.00005C1.33312 3.1738 2.77562 1.71755 4.55687 1.71755C5.22187 1.71755 6.585 2.56693 7.63812 3.51818C8.45562 4.25693 8.81938 4.70443 9.07625 5.00005C8.81875 5.29568 8.455 5.74318 7.63812 6.48193ZM15.4481 8.28255C14.7831 8.28255 13.4194 7.43318 12.3662 6.48193C11.5506 5.74443 11.1856 5.29568 10.9288 5.00005C11.1856 4.70443 11.5506 4.25568 12.3662 3.51818C13.4194 2.56755 14.7819 1.71755 15.4481 1.71755C17.2306 1.71755 18.6663 3.1738 18.6663 5.00005C18.6663 6.8263 17.23 8.28255 15.4481 8.28255Z' fill='#EFF1F6'/>
                  </svg> : plan.calls}
                </StyledTableCell>
                <StyledTableCell component='th' scope='row'>
                  {!plan.active ?
                    <Link
                      to={{
                        pathname: '/profile',
                        state: {
                          linkTab: 'Plans'
                        }
                      }}
                      style={{ color: '#4895EF',
                        fontFamily: 'Inter',
                        fontSize: '14px',
                        fontStyle: 'normal',
                        fontWeight: '600',
                        lineHeight: '20px'
                      }}
                    >
                    + Add to Plan
                    </Link> : `$${convertAmount(plan.amount)}`
                  }
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        )

        }
      </Table>

    </TableContainer>
  );
};

export default MeterTable;
